module.exports = "/assets/packs/images/897091c99703bbb4f356567d6c5593b8.png";